import React from "react";

export type CheckBoxProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  label?: string;
};

const CheckBox = (
  { label, ...rest }: CheckBoxProps,
  ref: React.Ref<HTMLInputElement>
) => {
  return (
    <label className="checkbox-label">
      <input type="checkbox" {...rest} ref={ref} />
      <span>{label}</span>
    </label>
  );
};

export default React.forwardRef(CheckBox);
